import DapDSDivider from './divider.component'

export * from './divider.component'
export default DapDSDivider

DapDSDivider.define()

declare global {
  interface HTMLElementTagNameMap {
    'dap-ds-divider': DapDSDivider
  }
}
